import { Bounce, ToastOptions, toast } from 'react-toastify';

import React from 'react';

const defaultToastOptions: ToastOptions = {
    autoClose: 5000,
    closeOnClick: true,
    draggable: false,
    hideProgressBar: false,
    pauseOnHover: true,
    progress: undefined,
    style: {
        borderRadius: 0,
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.5)',
        color: '#212529',
        fontFamily: 'Open Sans',
        fontSize: 14,
        maxWidth: '600px',
        minWidth: '300px',
        padding: '12px 30px 12px 20px',
        width: 'auto'
    },
    theme: 'light',
    transition: Bounce,
};

export const showErrorToast = (message: React.ReactNode, options?: ToastOptions) => {
    toast.error(message, {
        ...defaultToastOptions,
        ...{ containerId: 'error', autoClose: false, ...options },
    });
};

export const showInfoToast = (message: React.ReactNode, options?: ToastOptions) => {
    toast.info(message, { ...defaultToastOptions, ...{ containerId: 'success', ...options } });
};

export const showSuccessToast = (message: React.ReactNode, options?: ToastOptions) => {
    toast.success(message, { ...defaultToastOptions, ...{ containerId: 'success', ...options } });
};
